import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Create a new blog category
export const createBlogCategory = async (categoryData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.BLOG_CATEGORIES.CREATE, categoryData);
    return response.data;
  } catch (error) {
    console.error('Error creating blog category:', error);
    throw error;
  }
};

// Update an existing blog category
export const updateBlogCategory = async (payload) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.BLOG_CATEGORIES.UPDATE}/${payload?.categoryId}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating blog category:', error);
    throw error;
  }
};

// Get all blog categories with pagination
export const getBlogCategories = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams?.page || 1,
      search: queryParams?.search || '',
    };

    const response = await axiosInstance.get(API_ROUTES.BLOG_CATEGORIES.GET, { params });
    return response?.data;
  } catch (error) {
    console.error('Error fetching blog categories:', error);
    throw error;
  }
};

// Get all blog categories without pagination (for dropdowns)
export const getAllBlogCategories = async () => {
  try {
    const response = await axiosInstance.get(API_ROUTES.BLOG_CATEGORIES.GET_ALL);
    return response.data;
  } catch (error) {
    console.error('Error fetching all blog categories:', error);
    throw error;
  }
};

// Get single blog category
export const getBlogCategory = async (categoryId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.BLOG_CATEGORIES.GET_SINGLE}/${categoryId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching blog category:', error);
    throw error;
  }
};

// Delete one or multiple blog categories
export const deleteBlogCategory = async (categoryIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.BLOG_CATEGORIES.DELETE, {
      data: {
        ids: Array.isArray(categoryIds) ? categoryIds : [categoryIds]
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting blog categories:', error);
    throw error;
  }
};

const blogCategoriesApi = {
  createBlogCategory,
  updateBlogCategory,
  getBlogCategories,
  getAllBlogCategories,
  getBlogCategory,
  deleteBlogCategory,
};

export default blogCategoriesApi;
